// Default website content — mirrors backend DEFAULT_SITE_CONTENT.
// Used as a fallback so the landing page never renders empty.
export const DEFAULT_CONTENT = {
  hero: {
    badge: "Ilese, Ogun State",
    title1: "Fresh. Ethical.",
    title2: "Sustainable.",
    subtitle:
      "Modav Farms delivers premium livestock, fish, snails, poultry, and farm-fresh crops grown with care. We are committed to quality farming, healthy food, and community impact.",
    image_file: "",
  },
  produce: [
    { title: "Goats", text: "Healthy, well-fed, and ideal for fresh meat supply." },
    { title: "Pigs", text: "Premium pork raised in clean, controlled environments." },
    { title: "Fish", text: "Catfish and tilapia from our modern aquaculture system." },
    { title: "Snails", text: "Large, healthy snails for consumption and breeding." },
    { title: "Poultry", text: "Eggs and broilers raised with proper nutrition." },
    { title: "Crops", text: "Vegetables, fruits, and grains grown seasonally." },
  ],
  why: [
    { title: "Ethical & Sustainable", text: "Farming that respects animals, people and the land." },
    { title: "Clean Facilities", text: "Well-managed, hygienic pens, ponds and units." },
    { title: "Transparent Process", text: "Honest, traceable farm-to-table practices." },
    { title: "Fresh & High Quality", text: "Premium produce, harvested at its best." },
    { title: "Trusted Supply", text: "Relied on by families, restaurants and retailers." },
  ],
  about: {
    title: "Healthy food, empowered community",
    story1:
      "Modav Farms was founded with a simple mission: to produce healthy, high-quality food while empowering our local community. Located in Ilese, Ogun State, we combine traditional farming values with modern agricultural practices.",
    story2: "Our team is committed to excellence, sustainability, and transparency in everything we do.",
    values: ["Integrity", "Sustainability", "Quality", "Community Impact"],
    gallery: ["Clean livestock pens", "Modern fish ponds", "Hygienic snail & poultry units", "Crop fields managed with care"],
    image_file: "",
  },
  testimonials: [
    { quote: "Modav Farms is my number one source for fresh meat. Always reliable.", by: "Local Customer, Ogun State", image_file: "" },
    { quote: "Their snails and fish are top quality. Highly recommended.", by: "Restaurant Owner, Ijebu Area", image_file: "" },
  ],
  updates: [
    "New batch of snails available for wholesale",
    "Fresh catfish harvest this week",
    "Poultry unit expansion completed",
    "Community outreach program for local farmers",
  ],
  contact: {
    address: "No. 13 Gborogun Rd, Oke Quarters, Ilese, Ogun State",
    phone: "+234 7061797432",
    email: "Modavfarms@gmail.com",
    whatsapp: "2347061797432",
    instagram: "", facebook: "", tiktok: "",
  },
  footer: {
    tagline: "Fresh. Ethical. Sustainable.",
    subline: "Powered by community and innovation.",
  },
};

// Shallow-merge each top-level section over defaults so missing keys fall back.
export function mergeContent(c) {
  if (!c) return DEFAULT_CONTENT;
  const out = { ...DEFAULT_CONTENT };
  for (const k of Object.keys(DEFAULT_CONTENT)) {
    const v = c[k];
    if (v == null) continue;
    if (Array.isArray(DEFAULT_CONTENT[k])) out[k] = Array.isArray(v) && v.length ? v : DEFAULT_CONTENT[k];
    else if (typeof DEFAULT_CONTENT[k] === "object") out[k] = { ...DEFAULT_CONTENT[k], ...v };
    else out[k] = v;
  }
  return out;
}
